/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const StyledP = styled('p')`
  color: ${({ theme }) => theme.text.dark};
  font-size: 16px;
  margin: 16px 0 0;

  strong {
    display: block;
  }

  span {
    fon
  }

  &:last-child {
    margin-bottom: 0;
  }

  @media only screen and (max-width: 499px) {
    width: 100%;
  }

  @media only screen and (min-width: 500px) and (max-width: 768px) {
    padding-right: 16px;
    flex-grow: 1;
  }
`;

const StyledTitle = styled('strong')`
  color: ${({ theme }) => theme.text.dark};
  font-size: 16px;
  font-weight: 500;
`;

const SidebarDetail = ({ children, title, ...rest }) => (
  <StyledP {...rest}>
    {title && <StyledTitle>{title}</StyledTitle>}
    {children}
  </StyledP>
);

SidebarDetail.propTypes = {
  children: PropTypes.any,
  title: PropTypes.node,
};

export default SidebarDetail;
